import axios from 'axios';
import ToastEventBus from 'primevue/toasteventbus';
import {useDate} from "./hooks/useDate";
import {isObject} from "lodash";
import {serialize} from "object-to-formdata";
import {transform} from "@asanovr/object-transformer";
import router from "./routes";
import store from "./store";

const service = axios.create({
  headers: {
    common: {
      'X-Requested-With': 'XMLHttpRequest',
    }
  },

  withCredentials: true
});


const {date} = useDate();
const isoDateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?(?:[-+]\d{2}:?\d{2}|Z)?$/;

function isIsoDateString(value) {
  return value && typeof value === "string" && isoDateFormat.test(value);
}

service.interceptors.request.use(request => {
  let hasFiles = false;

  if (isObject(request.data)) {
    transform(request.data, value => {
      if (date.isDayjs(value)) {
        return value.toISOString();
      }

      if (!hasFiles && (value instanceof File || value instanceof Blob)) {
        hasFiles = true;
      }

      return value;
    });
  }

  if (hasFiles) {
    request.data = serialize(request.data, {
      booleansAsIntegers: true,
      indices: true
    })
  }

  return request;
})


service.interceptors.response.use(({data}) => {
  if (data.data) {

    transform(data, value => {
      if (isIsoDateString(value)) {
        return date.utc(value);
      }

      return value;
    });
  }

  return data;
});

service.interceptors.response.use(
  response => response,
  async error => {
    let message = error.response?.data?.message || error.message;

    if (!error?.config?.silence) {
      if (error.response.status === 401 || error.response.status === 419) {

        ToastEventBus.emit('add', {severity: 'error', summary: 'Login has expired. Please login again', life: 5000});

        await store.dispatch('auth/logout');
        await router.push('/login')
      } else if (error.response.status !== 403) {
        ToastEventBus.emit('add', {severity: 'error', summary: message, life: 5000});
      }
    }

    throw error;
  }
);

export default service
